module.exports = __webpack_public_path__ + "img/mobile-add-new-filter.1d757f59.png";